module.exports = __webpack_public_path__ + "static/img/1.88bf1e7.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/1/eng/1.png
// module id = 28bg
// module chunks = 0